// src/constants/steps.js
import {
  FileSignature,
  ClipboardList,
  Brain,
  FileText,
  Shield,
  XCircle,
} from "lucide-react";

export const STEPS_CONFIG = {
  consent: {
    title: "Consent & Confidentiality",
    description: "Client consent and confidentiality agreement",
    icon: FileSignature,
    isRequired: true,
  },
  intake: {
    title: "Initial Assessment",
    description: "Gather client information and history",
    icon: ClipboardList,
    isRequired: true,
  },
  mentalStatus: {
    title: "Mental Status Examination",
    description: "Assess client's current mental state",
    icon: Brain,
    isRequired: true,
  },
  // record: {
  //   title: "Counseling Record",
  //   description: "Session progress and interventions",
  //   icon: FileText,
  //   isRequired: true,
  // },

};
export const ADDITIONAL_FORMS = {
  safety: {
    title: "Safety Assessment",
    description: "Evaluate risk and safety concerns",
    icon: Shield,
    isRequired: true,
  },
  termination: {
    title: "Termination",
    description: "Complete counseling termination",
    icon: XCircle,
    isRequired: false,
    isOptional: true
  },
};

// src/constants/sessionData.js
export const INITIAL_SESSION_DATA = {
  consent: {
    clientName: "",
    clientSignature: "",  // ✅ Added: Matches form structure
    counselorName: "",
    counselorPosition: "",
    counselorSignature: "", // ✅ Added: Matches form structure
    signedAt: new Date().toISOString().split("T")[0],
    emergencyContact: {
      name: "",
      relationship: "",
      phone: "",
    },
  },
  mentalStatusExam: {
    appearance: {
      dressing: "",
      grooming: "",
      age: "",
    },
    attitude: "",
    behavior: {
      ritualized: "",
      unwantedBehavior: "",
      nonverbalBehavior: "",
      activityLevel: "",
    },
    speech: {
      style: "",
      volume: "",
      speed: "",
      tone: "",
    },
    mood: "",
    affect: "",
    orientation: "",
    cognition: "",
    // thoughtContent: "",
    thoughtContent: {
      contentAndOrganization: '',
      negativeThinking: '',
      obsessions: '',
      phobias: '',
      suicidalIdeation: '',
      homicidalIdeation: '',
      homicidalPlan: '',
      homicidalIntent: '',
      homicidalMeans: '',
      other: ''  // Added for free-form additional notes
    },
    perceptualDisturbances: "",
    memory: {
      shortTerm: "",
      longTerm: "",
    },
    concentration: "",
    insight: "",
    judgment: "",
  },
  record: {
    sessionNumber: "",
  },
  intake: {
    presentingProblems: [],
    impactOnFunctioning: {
      current: "",
      past: "",
    },
    history: {
      pastCounseling: "",
      familyBackground: "",
      medicalHistory: "",
      substanceUseHistory: ""
    },

    goals: [],
    diagnosis: "",
    interventionsUsed: "",
    nextSteps: "",
  },

};
